export default "__VITE_ASSET__49bc08d4__"